module.exports = __webpack_public_path__ + "static/img/support.1b2e4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/tiles/support.png
// module id = wInF
// module chunks = 1